import { FileText, Globe, LayoutDashboard, Lightbulb, type LucideIcon, Target, User } from 'lucide-react';
import { ePath } from '@/utils/paths';

/**
 * The founder portal's navigation. A fixed list, deliberately outside the
 * configurable resource matrix (`resources.ts`): the B2C portal is governed by
 * authentication, the founder's approval state (`ApprovedOnlyGuard`) and their
 * platform entitlement (`FoundersHubParticipantRoute`), never by per-role
 * view/edit cells. The six `ent_*` resources that used to back these rows
 * gated nothing and were retired.
 */
export interface EntrepreneurNavEntry {
  id: string;
  route: string;
  icon: LucideIcon;
  labelKey: string;
}

export const ENTREPRENEUR_NAV: EntrepreneurNavEntry[] = [
  { id: 'portal-overview', route: ePath('/dashboard'), icon: LayoutDashboard, labelKey: 'sidebar.entrepreneur.overview' },
  { id: 'portal-my-opportunities', route: ePath('/my-opportunities'), icon: Lightbulb, labelKey: 'sidebar.entrepreneur.myOpportunities' },
  { id: 'portal-matched-opportunities', route: ePath('/matched-opportunities'), icon: Target, labelKey: 'sidebar.entrepreneur.opportunities' },
  { id: 'portal-sectors', route: ePath('/industries'), icon: Globe, labelKey: 'sidebar.entrepreneur.sectors' },
  { id: 'portal-applications', route: ePath('/applications'), icon: FileText, labelKey: 'sidebar.entrepreneur.applications' },
  { id: 'portal-profile', route: ePath('/me'), icon: User, labelKey: 'sidebar.entrepreneur.profile' },
];
